var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{style:('border: 0;' + _vm.addStyle),attrs:{"src":_vm.src,"seamless":""}})}
var staticRenderFns = []

export { render, staticRenderFns }